export function prepareHtml(html: string, mobile: boolean) {
    const mobileStyle = `
        .es-content-body p {
            font-size: 18px !important;
            line-height: 24px !important;
        }
        .sinopsys-title {
            font-size: 16px !important;
            line-height: 22px !important;
        }
    `;
    return `
        ${html
            .replaceAll('<a ', '<a target="_blank" ')
            .replaceAll('border-left:10px solid transparent;', '')
            .replaceAll('border-right:10px solid transparent;', '')
            .replaceAll('"600"', '"580"')}
        <style>
            body { margin: 0; }

            .lphide { display: none; }

            h1, h2 {
                line-height: 36px !important;
            }

            ${mobile ? mobileStyle : ''}
        </style>
    `;
}
